import ExcelJS from "exceljs";
import axios from "axios";
import { Text } from "components";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver
import { toast } from "react-toastify";
import Pagination from "pages/Pagination/Pagination";
import Select from "react-select";
import { pageSize } from "components/PaginationPageSize";
import { formatQuantity, formatRupee } from "utils/helpingMethods/formatRupee";
import Code from "components/SmallComponents/Code";
import Swal from "sweetalert2";

const TaxInvoiceSalesReport = forwardRef((props, ref) => {
  const [currentStock, setCurrentStock] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  // const navigate = useNavigate();
  const gridRef = useRef();
  // Get the current date and format it as yyyy-mm-dd for the date input field
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 2); // Go back one month
  // const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split("T")[0];
  const [selectItem, setSelecteItem] = useState();
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [customerId, setCustomerId] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [items, setItems] = useState([]);
  const [searchItemsInput, setSearchItemsInput] = useState("");

  // Get the first day of the current month
  const firstDayOfCurrentMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );

  // Format it manually to ensure no timezone shift
  const formattedThirtyDaysAgo = `${firstDayOfCurrentMonth.getFullYear()}-${String(
    firstDayOfCurrentMonth.getMonth() + 1
  ).padStart(2, "0")}-01`;

  //for pagination...
  const [count, setCount] = useState();
  const [download, setDownload] = useState(false);

  //for serach fuctionallity ...

  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [formDate, setFormDate] = useState(formattedThirtyDaysAgo);
  // const [formDate, setFormDate] = useState(formattedThirtyDaysAgo);
  const [toDate, setToDate] = useState(formattedToday);
  const [recordPerPage, setRecordPerPage] = useState(pageSize);
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();
  const token = sessionStorage.getItem("token");
  const companyId = sessionStorage.getItem("companyId");
  const companyName = sessionStorage.getItem("companyName");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getCompanyDetails();
  }, []);
  useEffect(() => {
    getCustomerList();
  }, [searchInput]);

  const getCustomerList = () => {
    axios
      .post("/api/purple-fusion/customer/get", { name: searchInput }, headers)
      .then((response) => {
        setCustomerList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };
  useEffect(() => {
    getItemList();
  }, [searchItemsInput]);

  const getItemList = () => {
    const Item_obj = { search_parameter: searchItemsInput };
    axios
      .post("/api/purple-fusion/itemdetail/getforsearch", Item_obj, {
        ...headers,
        timeout: 20000,
      })
      .then((res) => {
        setItems(res.data);
        // console.log("item", res.data);
        console.log(
          "item",
          res.data.map(({ id, name }) => ({ id, name }))
        );
      })
      .catch((e) => {
        console.error("Error in fetching data ", e);
      });
  };

  const filterOption = (option, inputValue) => {
    const { label, code, code_op } = option.data;

    const labelMatch =
      label?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeMatch =
      code?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeOpMatch =
      code_op?.toLowerCase().includes(inputValue.toLowerCase()) || false;

    return labelMatch || codeMatch || codeOpMatch;
  };

  const formatOptionLabel = ({ label, code, code_op }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ marginLeft: 0 }}>{label}</div>
      <div style={{ marginLeft: 20 }}>{code_op}</div>
      <div style={{ marginLeft: 20 }}>{code}</div>
    </div>
  );

  // console.log(companyId);
  const obj_company = { id: companyId };
  const getCompanyDetails = () => {
    axios
      .post("/api/purple-fusion/company/get", obj_company, headers)
      .then((response) => {
        setCompanyDetails(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  useEffect(() => {
    getTaxInvoiceSales();
  }, [page, recordPerPage, formDate, toDate, selectItem, customerId]);

  useEffect(() => {
    if (
      formDate !== "" &&
      toDate !== "" &&
      searchParameter2 !== "" &&
      searchCompanySpecificDateRangeId === 7 &&
      page
    ) {
      obj.search_parameter = searchParameter2;
      getTaxInvoiceSales();
    }
  }, [page, searchParameter2]);

  const validateToDate = (newToDate) => {
    if (formDate) {
      const from = new Date(formDate);
      const maxToDate = new Date(from.setDate(from.getDate() + 366))
        .toISOString()
        .split("T")[0];

      if (newToDate > maxToDate) {
        toast.error(
          'The "To" date must be within 366 days after the "From" date.'
        );
        setToDate(maxToDate); // Reset to maximum allowed date
      } else {
        setToDate(newToDate);
      }
    }
  };

  const obj = {
    start_date: formDate,
    end_date: toDate,
    customer_id: customerId,
    item_detail_id: selectItem?.value,
    company_id: companyId,
  };

  const getTaxInvoiceSales = () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;
    console.log(offset);

    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };
    axios
      .post(
        "/api/purple-fusion/reporttaxinvoicesales/get",
        requestPayload,
        headers
      )
      .then((response) => {
        setCurrentStock(response.data);
        setCount(response.data[0].count);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const sortedInvoice = currentStock
    .slice()
    .sort((a, b) => b.tax_invoice_id - a.tax_invoice_id);

  const onBtnExport = useCallback(async () => {
    const excludedFields = ["id"]; // Fields to exclude from the export
    const visibleColumns = defaultColDefs.filter(
      (column) => !excludedFields.includes(column.field)
    );

    // Retrieve all data from the grid
    const allRows = [];
    gridRef.current.api.forEachNode((node) => allRows.push(node.data));

    // Helper to format dates to dd/mm/yyyy
    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-GB"); // Format as dd/mm/yyyy
    };

    const formattedData = allRows.map((row) => {
      const formattedRow = {};

      visibleColumns.forEach((col) => {
        if (col.field === "createdon" && row[col.field]) {
          formattedRow[col.headerName] = formatDate(row[col.field]); // Format createdon as date-only
        } else if (col.headerName === "GST%") {
          formattedRow["GST%"] =
            row.igst_percentage !== 0 && row.igst_percentage !== undefined
              ? row.igst_percentage
              : (row.cgst_percentage || 0) + (row.sgst_percentage || 0);
        } else if (col.headerName === "INTEGRATED TAX(igst)") {
          formattedRow["INTEGRATED TAX(igst)"] =
            row.igst_amount !== 0 && row.igst_amount !== undefined
              ? row.igst_amount
              : 0;
        } else if (col.headerName === "CENTRAL TAX(cgst)") {
          formattedRow["CENTRAL TAX(cgst)"] =
            row.cgst_amount !== 0 && row.cgst_amount !== null
              ? row.cgst_amount
              : 0;
        } else if (col.headerName === "STATE TAX(sgst)") {
          formattedRow["STATE TAX(sgst)"] =
            row.sgst_amount && row.sgst_amount !== 0 ? row.sgst_amount : 0;
        } else if (col.headerName === "CGST %") {
          formattedRow["CGST %"] =
            row.cgst_percentage && row.cgst_percentage !== 0
              ? row.cgst_percentage
              : 0;
        } else if (col.headerName === "SGST %") {
          formattedRow["SGST %"] =
            row.sgst_percentage && row.sgst_percentage !== 0
              ? row.sgst_percentage
              : 0;
        } else {
          formattedRow[col.headerName] = row[col.field] || "";
        }
      });

      return formattedRow;
    });

    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    console.log(companyDetails);

    // Add report metadata rows
    if (companyDetails.length > 0) {
      worksheet.addRow(["Company Name:", `${companyDetails[0]?.name}`]);
      worksheet.addRow(["Company GSTIN:", `${companyDetails[0]?.gstnumber}`]);

      const address =
        `${companyDetails[0]?.city}, ` +
        `pincode: ${companyDetails[0]?.pincode}, ` +
        `distt.: ${companyDetails[0]?.district_name}, ` +
        `State: ${companyDetails[0]?.state_name}`;

      const addressRow = worksheet.addRow(["Company Address:", address]);

      const rowIndex = addressRow.number;

      // Merge columns B to E (or more, depending on your layout)
      worksheet.mergeCells(`B${rowIndex}:K ${rowIndex}`);

      // Optional: Wrap text in merged cell
      const cell = worksheet.getCell(`B${rowIndex}`);
      cell.alignment = { wrapText: true, vertical: "top" };
    }
    worksheet.addRow(["Report Name:", `Sales Register Report`]);
    const dateFormatted = new Date(formDate).toLocaleDateString("en-GB"); // Format from date as dd/mm/yyyy
    worksheet.addRow(["From:", dateFormatted]);
    worksheet.addRow(["To Date:", toDate ? formatDate(toDate) : ""]);
    // if (selectItem && selectItem.label !== "All Items") {
    //   worksheet.addRow(["Item Name:", selectItem.label]):
    // }
    worksheet.addRow([]); // Add an empty row for spacing

    // Add header row
    const headers = visibleColumns.map((col) => col.headerName);
    worksheet.addRow(headers);

    // Freeze the header row
    let headerRow = null;
    if (companyDetails.length > 0) {
      worksheet.views = [{ state: "frozen", ySplit: 8 }];
    } else {
      worksheet.views = [{ state: "frozen", ySplit: 5 }];
    }

    // Style the header row
    if (companyDetails.length > 0) {
      headerRow = worksheet.getRow(8);
    } else {
      headerRow = worksheet.getRow(5);
    }
    // headerRow = worksheet.getRow(5);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" }, // Blue background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });
    headerRow.height = 30;

    formattedData.forEach((row, index) => {
      // Create an array of row data based on the headers
      const rowData = headers.map((header) => {
        const value = row[header];

        // Ensure 0 is explicitly set if it's missing or empty
        if (
          value === 0 ||
          value === "0" ||
          value === null ||
          value === undefined
        ) {
          return 0; // Explicitly return 0 for missing or empty values
        }

        return value || ""; // Return the value or an empty string if it's falsy
      });

      // Add the row to the worksheet
      const newRow = worksheet.addRow(rowData);
      newRow.height = 30; // Adjust row height

      // Iterate over each cell in the row for custom alignment
      newRow.eachCell((cell, colNumber) => {
        const columnHeader = headers[colNumber - 1]; // Map cell index to column header

        // Apply alignment based on data type
        cell.alignment = {
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "right" : "center", // Align numeric values to right
          wrapText: columnHeader === "DESCRIPTION", // Enable wrapText for DESCRIPTION column only
        };

        // Apply number format for numeric values with comma separator
        if (typeof cell.value === "number") {
          cell.numFmt = cell.value % 1 === 0 ? "#,##0" : "#,##0.00"; // Integer vs decimal format
        }

        // If the cell value is 0, ensure it displays as "0" properly
        if (cell.value === 0) {
          cell.numFmt = "#,##0"; // Format zero correctly
        }
      });
    });

    // Add total row at the bottom of the table
    const formatNumberWithCommas = (num) => {
      if (isNaN(num) || num === null || num === undefined) return "";
      return new Intl.NumberFormat("en-IN").format(num);
    };

    const totalRow = {};
    headers.forEach((header) => {
      if (header === "DESCRIPTION") {
        totalRow[header] = "Total"; // Add "Total" in the DESCRIPTION column
      } else if (
        [
          "QTY",
          "RATE",
          "TOTAL TAXABLE AMOUNT",
          "INTEGRATED TAX(igst)",
          "CENTRAL TAX(cgst)",
          "STATE TAX(sgst)",
          "TOTAL TAX",
          "GRAND TOTAL",
        ].includes(header)
      ) {
        // Calculate total and format with commas
        const total = formattedData.reduce(
          (sum, row) => sum + (parseFloat(row[header]) || 0),
          0
        );
        totalRow[header] = formatNumberWithCommas(total);
      } else {
        totalRow[header] = ""; // Leave other columns blank
      }
    });

    // Add the total row to the worksheet
    const totalDataRow = headers.map((header) => totalRow[header] || "");
    const footerRow = worksheet.addRow(totalDataRow);

    // Style the footer row
    footerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "right" };
      if (cell.value) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFB7E1CD" }, // Light green background
        };
      }
    });
    footerRow.height = 30;

    // Generate Excel file as a Blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Sales_Register_${formDate}_${toDate}.xlsx`);
  }, [formDate, toDate, selectItem]);

  const defaultColDefs = [
    { headerName: "Sr.No.", field: "sr", width: 85, headerClass: "font-bold" },
    {
      headerName: "INVOICE No.",
      field: "tax_invoice_code",
      width: 130,
      headerClass: "font-bold",
      cellRenderer: (params) => <Code>{params.value}</Code>,
    },
    {
      headerName: "INVOICE DATE",
      field: "createdon",
      width: 130,
      headerClass: "font-bold",
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
        }
        return "";
      },
    },
    {
      headerName: "PARTY NAME",
      field: "customer_name",
      width: 200,
      headerClass: "font-bold",
    },
    {
      headerName: "Billing Address",
      field: "billing_address",
      width: 200,
      headerClass: "font-bold",
    },
    {
      headerName: "STATE CODE",
      field: "state_gst_code",
      width: 80,
      headerClass: "font-bold",
    },
    {
      headerName: "STATE NAME",
      field: "state_name",
      width: 130,
      headerClass: "font-bold",
    },
    {
      headerName: "CUSTOMER PO No.",
      field: "purchase_order_number",
      width: 130,
      headerClass: "font-bold",
    },
    {
      headerName: "CUSTOMER PO DATE",
      field: "purchase_order_date",
      width: 130,
      headerClass: "font-bold",
    },
    {
      headerName: "GST NUMBER",
      field: "gst_number",
      width: 140,
      headerClass: "font-bold",
    },
    {
      headerName: "HSN CODE",
      field: "hsn_code",
      width: 140,
      headerClass: "font-bold",
    },
    {
      headerName: "SAC CODE",
      field: "sac_code",
      width: 140,
      headerClass: "font-bold",
    },
    {
      headerName: "PART No.",
      field: "code_op",
      width: 150,
      headerClass: "font-bold",
    },
    {
      headerName: "Item Category",
      field: "item_category_name",
      width: 150,
      headerClass: "font-bold",
    },
    {
      headerName: "Item Category Code",
      field: "item_category_code",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "DESCRIPTION",
      field: "itemname",
      width: 200,
      headerClass: "font-bold",
    },
    {
      headerName: "QTY",
      field: "quantity",
      width: 90,
      headerClass: "font-bold",
      valueFormatter: (params) => formatQuantity(params.value),
    },
    {
      headerName: "UOM",
      field: "uom",
      width: 90,
      headerClass: "font-bold",
    },
    {
      headerName: "RATE",
      field: "cost_price",
      width: 100,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "TOTAL TAXABLE AMOUNT",
      field: "item_amount",
      width: 100,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },

    {
      headerName: "GST%",
      field: "gst_percentage",
      width: 100,
      headerClass: "font-bold",
      valueGetter: (params) => {
        const { igst_percentage, cgst_percentage, sgst_percentage } =
          params.data;
        return igst_percentage !== 0 && igst_percentage !== undefined
          ? igst_percentage
          : (cgst_percentage || 0) + (sgst_percentage || 0);
      },
    },
    {
      headerName: "IGST %",
      field: "igst_percentage",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "CGST %",
      field: "cgst_percentage",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "SGST %",
      field: "sgst_percentage",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "INTEGRATED TAX(igst)",
      field: "igst_amount",
      width: 105,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "CENTRAL TAX(cgst)",
      field: "cgst_amount",
      width: 105,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "STATE TAX(sgst)",
      field: "sgst_amount",
      width: 105,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "TOTAL TAX",
      field: "total_tax",
      width: 105,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "GRAND TOTAL",
      field: "total_amount",
      width: 100,
      headerClass: "font-bold",
      valueFormatter: (params) => formatRupee(params.value),
    },
    {
      headerName: "Transporter Name",
      field: "transname",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "Transporter GST",
      field: "transid",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "Vehicle No.",
      field: "vehno",
      width: 100,
      headerClass: "font-bold",
    },
    {
      headerName: "CREATED BY",
      field: "createdby",
      width: 100,
      headerClass: "font-bold",
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(defaultColDefs);
  }, []);

  const ColDefaultVale = { filter: true };
  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px", // Adjust control height
      height: "35px", // Adjust control height
      fontSize: "14px", // Adjust font size
      width: "230px", // Adjust control width
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "35px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "35px",
      padding: "0 8px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "350px",
      backgroundColor: "#fff", // Ensures a solid background
      zIndex: 1000, // Ensures it appears above other elements
    }),
  };

  const downloadItemRevenueReport = async () => {
    console.log("obj");

    try {
      Swal.fire({
        title: "Processing...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axios.post(
        "/api/purple-fusion/reporttaxinvoicesales/download",
        {}, // POST body
        {
          params: {
            companyId: companyId,
            companyName: companyName,
            startDate: formDate,
            endDate: toDate,
            id: 0,
            taxInvoiceId: 0,
            customerId: customerId < 1 ? 0 : customerId,
            itemDetailId: selectItem?.value < 1 ? 0 : selectItem?.value,
            limit: 0,
            offset: 0,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );
      Swal.close();
      // Extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "Sales_Register_report.xlsx";

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create and trigger download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      Swal.close();
      alert("Failed to download report");
    }
  };

  const downloadExcel = useCallback(() => {
    // Your function logic here
    downloadItemRevenueReport();
  }, [page, recordPerPage, formDate, toDate, selectItem, customerId]);

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel,
    }),
    [downloadExcel]
  );

  return (
    <div>
      <div className="mb-1">
        <div className="flex flex-1 flex-row items-center justify-between w-full mt-1 pr-10 pl-5">
          <div className="flex flex-1 flex-row items-center justify-between w-full md:flex-col md:items-start md:justify-start sm:flex-col sm:items-start sm:justify-start ">
            <div className="flex flex-row gap-1 items-center">
              <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                From
              </Text>
              <input
                name="from_date"
                type="date"
                value={formDate}
                // onChange={(e) => setformDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  setCurrentStock([]);
                  setLoading(true);
                  setFormDate(e.target.value);
                  validateToDate(toDate); // Validate "To" date whenever "From" date changes
                }}
                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
              />
              <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                To
              </Text>
              <input
                name="to_date"
                type="date"
                value={toDate}
                // onChange={(e) => setToDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                min={formDate}
                onChange={(e) => {
                  setCurrentStock([]);
                  setLoading(true);
                  validateToDate(e.target.value);
                }}
                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
              />
              <Select
                options={[
                  { label: "All Customers", value: 0 },
                  ...customerList.map((customer) => ({
                    label: customer.name,
                    value: customer.id,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm "
                onChange={(selectedOption) => {
                  setCurrentStock([]);
                  setLoading(true);
                  setCustomerId(selectedOption.value);
                }}
                onInputChange={setSearchInput}
                placeholder="All Customer"
                styles={customStylesSelect}
              />
              <Select
                // options={items.map((purchase) => ({
                //   label: purchase.name,
                //   value: purchase.id,
                // }))}
                options={[
                  { label: "All Items", value: 0 },
                  ...items.map((item) => ({
                    label: item.name,
                    value: item.id,
                    code: item.code,
                    code_op: item.code_op,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[230px] mb-2 text-sm"
                onChange={(selectedOption) => {
                  setCurrentStock([]);
                  setLoading(true);
                  setSelecteItem(selectedOption);
                }}
                filterOption={filterOption}
                formatOptionLabel={formatOptionLabel}
                onInputChange={setSearchItemsInput}
                placeholder="Select Item"
                isSearchable
                styles={customStylesSelect}
              />
            </div>
            <div className="flex text-3xl  justify-end items-end font-inter px-[10px] leading-none  text-gray-900 md:text-4xl lg:text-5xl dark:text-white ">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 ${do} hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <a
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="ag-theme-quartz"
        // style={{ height: 435, width: "100%", fontSize: "12px" }}
        id="tab-grid-table"
      >
        <AgGridReact
          rowData={currentStock.map((item, index) => ({
            ...item,
            sr: index + (offsetforSR + 1),
            // Display "NA" if code_op is null
          }))}
          ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={ColDefaultVale}
          suppressMenuHide={true}
          suppressExcelExport={true}
          rowHeight={37}
          overlayLoadingTemplate={loading ? "Loading..." : null}
          overlayNoRowsTemplate={
            loading
              ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
              : "No Record Found"
          }
        />
      </div>

      <div>
        <Pagination
          count={count}
          setRecordPerPage={setRecordPerPage}
          recordPerPage={recordPerPage}
          setLoading={setLoading}
          setData={setCurrentStock}
          setPage={setPage}
          page={page}
        />
      </div>
    </div>
  );
});

export default TaxInvoiceSalesReport;
